import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';
import GameResultItem from '../../components/gameResultItem';
import { roundsWinBetTypes } from '../../store/roundsWinBetTypes';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';
import { BetShopResults } from '../../components/betShopStatistics/betShopResults';
import { BET_SHOP_GAME_ID } from '../../enums/constants';

const columnsCount = new Array(66).fill(null);
const resultRowCount = 6;

const GameResults = observer(function () {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isBetShop = +gameId === BET_SHOP_GAME_ID;

  const { winBetTypes } = roundsWinBetTypes;
  const resultsContainer = useRef();
  const memoWinBetTypes = useMemo(() => {
    if (winBetTypes) {
      const result = winBetTypes.filter((data) => data.roundData);
      if (result.length % resultRowCount) {
        const pseudoArray = new Array(resultRowCount - (result.length % resultRowCount)).fill(null);
        return result.concat(pseudoArray);
      }
      return result;
    }
    return null;
  }, [winBetTypes]);

  const pseudoWinBetTypesIds = useIdsGenerator(columnsCount, [memoWinBetTypes]);
  const winBetTypesIds = useIdsGenerator(memoWinBetTypes);

  const scrollToMyRef = useCallback(() => {
    if (!resultsContainer.current) return;
    resultsContainer.current.scrollLeft =
      resultsContainer.current.scrollWidth - resultsContainer.current.clientWidth + 1;
  }, [resultsContainer]);

  useEffect(() => {
    scrollToMyRef();
  }, [scrollToMyRef, winBetTypes]);

  if (isBetShop) {
    return (
      <BetShopResults
        winBetTypes={winBetTypes}
        resultsContainer={resultsContainer}
        winBetTypesIds={winBetTypesIds}
        memoWinBetTypes={memoWinBetTypes}
      />
    );
  }

  return (
    <div className='bottom-left-column' ref={resultsContainer}>
      <div className='bottom-left-column-inner'>
        <div className='left-column-sheet'>
          {!memoWinBetTypes || columnsCount.length > memoWinBetTypes.length
            ? columnsCount.map((item, index) => {
                return (
                  <GameResultItem
                    key={pseudoWinBetTypesIds[index]}
                    roundData={memoWinBetTypes?.[index]?.roundData || {}}
                  />
                );
              })
            : memoWinBetTypes.map((item, index) => {
                return (
                  <GameResultItem
                    key={winBetTypesIds[index]}
                    roundData={memoWinBetTypes?.[index]?.roundData || {}}
                  />
                );
              })}
        </div>
      </div>
    </div>
  );
});

export default GameResults;
